import { validateEnumTranslations } from '../../safety_checks';

/**
 * Périmètre géographique du SEO d'un professionnel.
 *
 * - `LOCAL` (défaut au signup) : le pro reçoit dans une zone ou se déplace.
 *   Templates SEO incluent `{area}`, JSON-LD = `LocalBusiness`, `areaServed`
 *   = liste des `service_areas[].name` (villes / départements / régions).
 * - `NATIONAL` : pas d'ancrage géographique (e-commerce, B2B, chaîne).
 *   Templates omettent `{area}`, JSON-LD = `Organization`, `areaServed`
 *   = `{ '@type': 'Country', name: national_label }`.
 *
 * Bascule LOCAL → NATIONAL : modale warning + saisie "JE CONFIRME".
 *
 * ⚠️ IMPACT : la colonne Prisma `professional.seo_scope` est typée `VARCHAR(20)`
 * avec default `'LOCAL'`. Toute valeur ajoutée ici doit être migrée DB.
 */
export enum SeoScope {
  LOCAL = 'LOCAL',
  NATIONAL = 'NATIONAL',
}

export const SEO_SCOPE_TRANSLATE_KEY = 'SEO_SCOPE_';

export const SeoScopeTranslation = {
  'fr-FR': {
    [`${SEO_SCOPE_TRANSLATE_KEY}${SeoScope.LOCAL}`]: 'Local',
    [`${SEO_SCOPE_TRANSLATE_KEY}${SeoScope.NATIONAL}`]: 'National',
  },
};

validateEnumTranslations(SeoScope, SeoScopeTranslation, SEO_SCOPE_TRANSLATE_KEY, true);
